import React, {memo, useState} from 'react';
import {setParameterToMap} from "actions/index.js";
import Colors from 'components/Colors.js';
import { connect } from "react-redux";

const colors = new Colors();

const ParameterButton = memo(({
    name,
    setParameterToMap,
    parameter,
    value,
    onClick,
    isMacroMapping,
    isParameterToMap,
    isSelected,
}) => {
    let className = "parameter-button";
    if (isSelected) {
        className += " selected";
    }

    const roundValue = (v) => {
        return Math.floor(v * 100.0) / 100;
    };

    const getMacroOverlayIfNeeded = () => {
        let param = parameter.parameter;
        if (isMacroMapping && param) {
            let className = "macro-overlay";
            if (isParameterToMap) {
                className += " parameter-to-map";
            }

            if (param.hasMacro) {
                className += " mapped";
            }

            let style = {
            };

            if (param.hasMacro) {
                style = {
                    backgroundColor: colors.getColorForHash(param.hasMacro.id)
                };
            }

            let text = param.hasMacro && param.hasMacro.name;

            return (
                <div
                  onClick={() => setParameterToMap(param)}
                  className={className}>
                  <div className="overlay-main"></div>
                  <div className="overlay-detail" style={style}>
                    {text}
                  </div>
                </div>
            );
        }

        return '';
    }

    return (
        <div
          onClick={() => onClick(parameter)}
          className={className}>
          {getMacroOverlayIfNeeded()}
          <div className="parameter-name">
            {name}
          </div>
          <div className="parameter-value">
            {roundValue(value)}
          </div>
        </div>
    );
});


const mapDispatchToProps = dispatch => {
    return {
        setParameterToMap: parameter => dispatch(setParameterToMap(parameter)),
    };
};
 
const mapStateToProps = (state, props) => {
    if (props.parameter === undefined) {
        return {
            value: 0,
        };
    }

    let rawValue = state.effects.effectParameters[props.parameter.parameter.id];
    return {
        value: rawValue,
        isMacroMapping: state.effects.isMacroMapping,
        isParameterToMap: props.parameter &&
            state.effects.parameterToMap === props.parameter.parameter,
        hasMacro: props.parameter.parameter.hasMacro
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(ParameterButton);


